module.exports = __webpack_public_path__ + "static/media/menu_corner_lower_right.84816630.png";